/**
 * Detects any single HTML/markup tag — opening (`<div>`), closing (`</div>`),
 * or self-closing (`<br/>`, `<img … />`). A `[a-zA-Z]` is required right after
 * the optional `/`, so prose comparisons like `a < b > c` do not match.
 *
 * This is a deliberately broad NOISE-REDUCTION heuristic, not a security
 * control. Its only job is to keep automated scanners and accidental markup
 * dumps out of the feedback Slack channel and API. It is enforced on the client
 * only, so it does nothing against a request sent directly to the backend — any
 * real XSS defense must live where the feedback is rendered.
 *
 * Known, intentional tradeoff: it also rejects legitimate feedback that happens
 * to contain a tag (JSX, HTML, XML config, stack traces, "the <Save> button").
 * We accept those false positives in exchange for a simple rule.
 */
const HTML_TAG = /<\/?[a-zA-Z][^>]*>/;

export function containsHtmlFragment(text: string): boolean {
  return HTML_TAG.test(text);
}
